import { DevNotice, useThemeProps } from "../../wsui/base";

import postsModuleContext from "./postsModuleContext.js";
import PostsModuleExpandableListLayout from "./PostsModuleExpandableListLayout.jsx";
import PostsModuleGridLayout from "./PostsModuleGridLayout.jsx";
import PostsModuleInlineListLayout from "./PostsModuleInlineListLayout.jsx";
import PostsModuleListLayout from "./PostsModuleListLayout.jsx";
import PostsModuleMixedLayout from "./PostsModuleMixedLayout.jsx";

function defaultDisplayModeMapping({ displayMode }) {
  switch (displayMode) {
    case "expandable-list":
      return PostsModuleExpandableListLayout;
    case "list":
      return PostsModuleListLayout;
    case "items":
    case "news":
    case "grid":
    case "index":
      return PostsModuleGridLayout;
    case "mixed":
      return PostsModuleMixedLayout;
    case "inline-list":
      return PostsModuleInlineListLayout;
  }
}

export default function PostsModule(props) {
  props = useThemeProps({ props, name: "MunicipioPostsModule" });
  let {
    title,
    titleIcon,
    description,
    displayMode,
    displayModeMapping = {},
    items,
    visibleFields = ["title"],
    itemVariant,
    itemColor,
    headingPosition,
    excerptLines,
    ...restProps
  } = props;

  const ownerState = {
    title,
    titleIcon,
    description,
    displayMode,
    items,
    displayModeMapping,
    visibleFields,
    itemVariant,
    itemColor,
    headingPosition,
    excerptLines,
    ...restProps,
  };

  const Component =
    (typeof displayModeMapping === "function"
      ? displayModeMapping(ownerState, defaultDisplayModeMapping)
      : displayModeMapping[displayMode]) ||
    defaultDisplayModeMapping(ownerState);

  if (!Component) {
    return (
      <DevNotice>{`No posts module component found for displayMode=${JSON.stringify(
        displayMode,
      )}`}</DevNotice>
    );
  }

  return (
    <postsModuleContext.Provider value={ownerState}>
      <Component
        title={title}
        titleIcon={titleIcon}
        description={description}
        items={items}
        {...restProps}
      />
    </postsModuleContext.Provider>
  );
}
